export const STORAGE_KEY_HISTORY = 'LOCAL_TOURNAMENTS_HISTORY' as const;
export const STORAGE_KEY_LAST_SHOWN_ID = 'LOCAL_TOURNAMENTS_LAST_SHOWN_ID' as const;

const TEST_CUSTOM_DELAY_TO_SHOW = Number(localStorage.getItem('TEST_CUSTOM_DELAY_TO_SHOW'));

export const DELAY_TO_SHOW = TEST_CUSTOM_DELAY_TO_SHOW || (86400000 as const); // 24 hours;

export const CUSTOM_EVENTS = {
  NEW_LOCAL_TOURNAMENT: 'NEW_LOCAL_TOURNAMENT',
  RESET_NEW_LOCAL_TOURNAMENT: 'RESET_NEW_LOCAL_TOURNAMENT'
} as const;
